import * as React from "react";
import { StyleSheet, View, Text, TouchableOpacity } from "react-native";
import { currentLanguage } from "../../translations/CurrentLanguage";

import Icon from "react-native-vector-icons/FontAwesome";
import translation from "../../translations/translation";
import LocalizedStrings from "react-native-localization";
import { colors, radius } from "../../theme/modern";

let strings = new LocalizedStrings(translation);

const FooterTicketComponent = props => {
  strings.setLanguage(currentLanguage().companyLanguage);
  const empty = props.totalQty === 0;
  const cannotPay = props.totalSubTotal === "0.00";

  return (
    <View style={styles.footer}>
      <TouchableOpacity
        activeOpacity={0.7}
        onPress={props.onDeleteClick}
        style={[styles.action, styles.danger]}
      >
        <Icon name="trash-o" size={20} color={colors.danger} />
      </TouchableOpacity>
      <TouchableOpacity
        activeOpacity={0.7}
        onPress={props.onBarcodeClick}
        style={styles.action}
      >
        <Icon name="barcode" size={20} color="#334155" />
      </TouchableOpacity>
      <TouchableOpacity
        activeOpacity={0.7}
        onPress={props.onDiscountClick}
        style={styles.action}
      >
        <Icon
          name="percent"
          size={17}
          color={empty ? colors.textFaint : "#334155"}
        />
      </TouchableOpacity>
      <TouchableOpacity
        activeOpacity={0.85}
        disabled={cannotPay}
        onPress={() => props.onPaymentClick(props.receipt)}
        style={[styles.pay, cannotPay ? styles.payDisabled : null]}
      >
        <Icon name="credit-card" size={18} color="#fff" />
        <Text style={styles.payText} numberOfLines={1}>
          {strings.Payment} ({props.totalQty})
        </Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  footer: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingTop: 12,
    paddingBottom: 16,
    backgroundColor: colors.surface,
  },
  action: {
    width: 48,
    height: 50,
    marginRight: 6,
    borderRadius: radius.medium,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f1f5f9",
  },
  danger: {
    backgroundColor: colors.dangerSoft,
  },
  pay: {
    flex: 1,
    height: 50,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: radius.medium,
    backgroundColor: colors.primary,
  },
  payDisabled: {
    backgroundColor: "#cbd5e1",
  },
  payText: {
    marginLeft: 8,
    color: "#fff",
    fontSize: 14,
    fontWeight: "700",
  },
});

export default FooterTicketComponent;
